import { useEffect } from 'react';
import { getSocket } from '../../socket';

export default function useMeetingAgendaUpdates(meetingId, refreshMeeting) {
  useEffect(() => {
    if (!meetingId) return undefined;
    const socket = getSocket();
    let refreshTimeout;
    const scheduleRefresh = () => {
      clearTimeout(refreshTimeout);
      refreshTimeout = setTimeout(() => {
        void refreshMeeting();
      }, 200);
    };
    const handleAgendaChanged = payload => {
      if (String(payload?.meetingId || '') === String(meetingId)) scheduleRefresh();
    };
    const handleConnect = () => {
      socket.emit('meeting:join', String(meetingId));
      scheduleRefresh();
    };
    socket.on('meeting:agenda-changed', handleAgendaChanged);
    socket.on('connect', handleConnect);
    socket.emit('meeting:join', String(meetingId));
    return () => {
      clearTimeout(refreshTimeout);
      socket.off('meeting:agenda-changed', handleAgendaChanged);
      socket.off('connect', handleConnect);
    };
  }, [meetingId, refreshMeeting]);
}
